import * as moment from 'moment';
import 'moment/locale/cs';

moment.locale('cs');
